import { Vector2 } from 'three/build/three.module.js';

export default {
  uniforms: {

    "strength": { value: 0.0 },
		"tDiffuse": { value: null },
		"resolution": { value: new Vector2( 1 / 1024, 1 / 512 ) }

	},
  vertexShader: `
    varying vec2 vUv;

    void main() 
    {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }`,
  fragmentShader: `
    uniform sampler2D tDiffuse;      // sampler of rendered scenes render target
    uniform vec2 resolution;
    uniform float strength;
    varying vec2 vUv;

    void main() {
      float radius = 32.0;
      vec2 dir = vec2(1.0, 1.0);

      // Normalized pixel coordinates (from 0 to 1)
      vec2 uv = gl_FragCoord.xy/resolution.xy;
      
      //the amount to blur, i.e. how far off center to sample from 
      //1.0 -> blur by one pixel
      //2.0 -> blur by two pixels, etc.
      vec2 blur = radius/resolution.xy;
        
      //the direction of our blur
      //(1.0, 0.0) -> x-axis blur
      //(0.0, 1.0) -> y-axis blur
      float hstep = dir.x;
      float vstep = dir.y;

      vec4 sum = vec4(0.0);
        
      //apply blurring, using a 9-tap filter with predefined gaussian weights
        
      sum += texture2D(tDiffuse, vec2(uv.x - 4.0*blur.x*hstep, uv.y - 4.0*blur*vstep)) * 0.0162162162;
      sum += texture2D(tDiffuse, vec2(uv.x - 3.0*blur.x*hstep, uv.y - 3.0*blur*vstep)) * 0.0540540541;
      sum += texture2D(tDiffuse, vec2(uv.x - 2.0*blur.x*hstep, uv.y - 2.0*blur*vstep)) * 0.1216216216;
      sum += texture2D(tDiffuse, vec2(uv.x - 1.0*blur.x*hstep, uv.y - 1.0*blur*vstep)) * 0.1945945946;
      
      sum += texture2D(tDiffuse, vec2(uv.x, uv.y)) * 0.2270270270;
      
      sum += texture2D(tDiffuse, vec2(uv.x + 1.0*blur.y*hstep, uv.y + 1.0*blur*vstep)) * 0.1945945946;
      sum += texture2D(tDiffuse, vec2(uv.x + 2.0*blur.y*hstep, uv.y + 2.0*blur*vstep)) * 0.1216216216;
      sum += texture2D(tDiffuse, vec2(uv.x + 3.0*blur.y*hstep, uv.y + 3.0*blur*vstep)) * 0.0540540541;
      sum += texture2D(tDiffuse, vec2(uv.x + 4.0*blur.y*hstep, uv.y + 4.0*blur*vstep)) * 0.0162162162;
      
      
      // Pixel colour
      vec4 vColor = texture2D(tDiffuse, uv);
      //discard alpha for our simple demo, multiply by vertex color and return
      // gl_FragColor = texture2D( tDiffuse, vUv );
      gl_FragColor = vColor * mix(vec4(1.0), vec4(sum.rgb, 1.0), strength);
    }`,
};
